var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.501 0C5.86802 0 0.500977 5.36752 0.500977 12C0.500977 18.633 5.86849 24 12.501 24C19.1339 24 24.501 18.6325 24.501 12C24.501 5.36705 19.1334 0 12.501 0ZM12.501 22.125C6.90443 22.125 2.37598 17.5962 2.37598 12C2.37598 6.40345 6.9048 1.875 12.501 1.875C18.0975 1.875 22.626 6.40383 22.626 12C22.626 17.5965 18.0971 22.125 12.501 22.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.501 10.0466C11.9832 10.0466 11.5635 10.4664 11.5635 10.9841V17.0213C11.5635 17.5391 11.9832 17.9588 12.501 17.9588C13.0188 17.9588 13.4385 17.539 13.4385 17.0213V10.9841C13.4385 10.4664 13.0188 10.0466 12.501 10.0466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.501 8.89868C13.2 8.89868 13.7666 8.33204 13.7666 7.63306C13.7666 6.93407 13.2 6.36743 12.501 6.36743C11.802 6.36743 11.2354 6.93407 11.2354 7.63306C11.2354 8.33204 11.802 8.89868 12.501 8.89868Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.500977)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info-white.e8046084f766a5b1b623c7a683438f7d.svg";
export { ForwardRef as ReactComponent };